import { makeStyles, fade } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
		borderRadius: theme.shape.borderRadius,
		background: fade(theme.palette.secondary.main, 0.1),
		minHeight: '100%',
		[theme.breakpoints.down('sm')]: {
			borderRadius: 12,
		},
	},
	header: {
		color: theme.palette.secondary.main,
		height: 35,
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'center',
	},
	title: {
		lineHeight: '1.1em',
	},
}));

export default useStyles;
